/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
import store from "../store";
export default [
  // This  allows you to have pages apart of the app but no rendered inside the dash
  {
    path: "/login",
    meta: {
      name: "",
      requiresAuth: false,
    },
    component: () =>
      import(/* webpackChunkName: "routes" */ `@/components/layout/ExternalPage.vue`),
    // redirect if already signed in
    beforeEnter: (to, from, next) => {
      if (store.getters.authorized) {
        next("/");
      } else {
        next();
      }
    },
    children: [
      {
        path: "",
        component: () => import(`@/views/account/Login.vue`),
      },
    ],
  },
  {
    path: "/account",
    meta: {
      name: "",
      requiresAuth: false,
    },
    component: () => import(`@/components/layout/ExternalPage.vue`),
    children: [
      {
        path: "setpassword",
        meta: {
          title: "setpassword",
        },
        component: () => import(`@/views/account/ResetPassword.vue`),
      },
      {
        path: "resetpassword",
        meta: {
          title: "resetpassword",
        },
        component: () => import(`@/views/account/ResetPassword.vue`),
      },
      {
        path: "forgotpassword",
        meta: {
          title: "forgotpassword",
        },
        component: () => import(`@/views/account/ForgotPassword.vue`),
      },
    ],
  },
  // add any extra routes that you want rendered in the dashboard as a child below. Change toolbar names here
  {
    path: "/",
    meta: {
      name: "Dashboard View",
      requiresAuth: true,
    },
    redirect: {
      path: "/dashboard",
    },
    component: () => import(`@/components/layout/InternalPage.vue`),
    children: [
      {
        path: "dashboard",
        meta: {
          title: "dashboard",
        },
        component: () => import(`@/views/Dashboard.vue`),
      },
      {
        path: "inbox",
        meta: {
          title: "inbox",
        },
        component: () => import(`@/views/client/Inbox.vue`),
      },
      {
        path: "dealer",
        meta: {
          title: "dealer",
        },
        component: () => import(`@/views/admin/Dealer.vue`),
      },
      {
        path: "company",
        meta: {
          title: "company",
        },
        component: () => import(`@/views/admin/Company.vue`),
      },
      {
        path: "setup/company",
        meta: {
          title: "company",
        },
        component: () => import(`@/views/client/setup/Company.vue`),
      },
      {
        path: "setup/overtime",
        meta: {
          title: "overtimesetup",
        },
        component: () => import(`@/views/client/setup/Overtime.vue`),
      },
      {
        path: "setup/officehour",
        meta: {
          title: "officehour",
        },
        component: () => import(`@/views/client/setup/OfficeHour.vue`),
      },
      {
        path: "setup/attendanceyear",
        meta: {
          title: "attendanceyear",
        },
        component: () => import(`@/views/client/setup/AttendanceYear.vue`),
      },
      {
        path: "setup/branch",
        meta: {
          title: "branch",
        },
        component: () => import(`@/views/client/setup/Branch.vue`),
      },
      {
        path: "setup/department",
        meta: {
          title: "department",
        },
        component: () => import(`@/views/client/setup/Department.vue`),
      },
      {
        path: "setup/designation",
        meta: {
          title: "designation",
        },
        component: () => import(`@/views/client/setup/Designation.vue`),
      },
      {
        path: "setup/mode",
        meta: {
          title: "mode",
        },
        component: () => import(`@/views/client/setup/Mode.vue`),
      },
      {
        path: "setup/type",
        meta: {
          title: "type",
        },
        component: () => import(`@/views/client/setup/Type.vue`),
      },
      {
        path: "setup/leave",
        meta: {
          title: "leave",
        },
        component: () => import(`@/views/client/setup/Leave.vue`),
      },
      {
        path: "setup/officialvisit",
        meta: {
          title: "officialvisit",
        },
        component: () => import(`@/views/client/setup/OfficialVisit.vue`),
      },
      {
        path: "setup/userpermission",
        meta: {
          title: "userpermission",
        },
        component: () => import(`@/views/client/setup/UserPermission.vue`),
      },
      {
        path: "personaldetail",
        meta: {
          title: "personaldetail",
        },
        component: () => import(`@/views/client/PersonalDetail.vue`),
      },
      {
        path: "posting/holiday",
        meta: {
          title: "holiday",
        },
        component: () => import(`@/views/client/posting/Holiday.vue`),
      },
      {
        path: "posting/attendance",
        meta: {
          title: "attendanceposting",
        },
        component: () => import(`@/views/client/posting/Attendance.vue`),
      },
      {
        path: "posting/officialvisitapplication",
        meta: {
          title: "officialvisitapplicationposting",
        },
        component: () =>
          import(`@/views/client/posting/OfficialVisitApplication.vue`),
      },
      {
        path: "posting/lateinearlyoutapplication",
        meta: {
          title: "lateinearlyoutapplicationposting",
        },
        component: () =>
          import(`@/views/client/posting/LateInEarlyOutApplication.vue`),
      },
      {
        path: "posting/dayoffworking",
        meta: {
          title: "dayoffworkingposting",
        },
        component: () => import(`@/views/client/posting/DayOffWorking.vue`),
      },
      {
        path: "posting/overtime",
        meta: {
          title: "overtimeposting",
        },
        component: () => import(`@/views/client/posting/Overtime.vue`),
      },
      {
        path: "posting/pendingapplication",
        meta: {
          title: "pendingapplicationposting",
        },
        component: () =>
          import(`@/views/client/posting/PendingApplication.vue`),
      },
      {
        path: "leave/posting",
        meta: {
          title: "leaveapplicationposting",
        },
        component: () => import(`@/views/client/leave/Posting.vue`),
      },
      {
        path: "leave/days/assignment",
        meta: {
          title: "leavedaysassignment",
        },
        component: () => import(`@/views/client/leave/DaysAssignment.vue`),
      },
      {
        path: "application/leave",
        meta: {
          title: "leaveapplication",
        },
        component: () => import(`@/views/client/application/Leave.vue`),
      },
      {
        path: "application/officialvisit",
        meta: {
          title: "officialvisitapplication",
        },
        component: () => import(`@/views/client/application/OfficialVisit.vue`),
      },
      {
        path: "application/lateinearlyout",
        meta: {
          title: "lateinearlyoutapplication",
        },
        component: () =>
          import(`@/views/client/application/LateInEarlyOut.vue`),
      },
      {
        path: "application/attendance",
        meta: {
          title: "attendanceapplication",
        },
        component: () => import(`@/views/client/application/Attendance.vue`),
      },
      // {
      //   path: "report/daily/absent",
      //   meta: {
      //     title: "dailyabsent",
      //   },
      //   component: () => import(`@/views/client/report/daily/Absent.vue`),
      // },
      {
        path: "report/daily/attendance",
        meta: {
          title: "dailyattendance",
        },
        component: () => import(`@/views/client/report/daily/Attendance.vue`),
      },
      // {
      //   path: "report/daily/lateinearlyout",
      //   meta: {
      //     title: "dailylateinearlyout",
      //   },
      //   component: () =>
      //     import(`@/views/client/report/daily/LateInEarlyOut.vue`),
      // },
      {
        path: "report/monthly/presentabsent",
        meta: {
          title: "monthlypresentabsent",
        },
        component: () =>
          import(`@/views/client/report/monthly/PresentAbsent.vue`),
      },
      {
        path: "report/monthly/attendancelog",
        meta: {
          title: "monthlyattendancelog",
        },
        component: () =>
          import(`@/views/client/report/monthly/AttendanceLog.vue`),
      },
      {
        path: "report/monthly/attendancesummary",
        meta: {
          title: "monthlyattendancesummary",
        },
        component: () =>
          import(`@/views/client/report/monthly/AttendanceSummary.vue`),
      },
      {
        path: "report/monthly/absent",
        meta: {
          title: "monthlyabsent",
        },
        component: () => import(`@/views/client/report/monthly/Absent.vue`),
      },
      {
        path: "report/monthly/lateinearlyout",
        meta: {
          title: "monthlylateinearlyout",
        },
        component: () =>
          import(`@/views/client/report/monthly/LateInEarlyOut.vue`),
      },
      {
        path: "report/monthly/ledger",
        meta: {
          title: "monthlyledger",
        },
        component: () => import(`@/views/client/report/monthly/Ledger.vue`),
      },
      {
        path: "report/yearly/presentabsent",
        meta: {
          title: "yearlypresentabsent",
        },
        component: () =>
          import(`@/views/client/report/yearly/PresentAbsent.vue`),
      },
      {
        path: "report/yearly/attendancelog",
        meta: {
          title: "yearlyattendancelog",
        },
        component: () =>
          import(`@/views/client/report/yearly/AttendanceLog.vue`),
      },
      {
        path: "report/yearly/absent",
        meta: {
          title: "yearlyabsent",
        },
        component: () => import(`@/views/client/report/yearly/Absent.vue`),
      },
      {
        path: "report/yearly/lateinearlyout",
        meta: {
          title: "yearlylateinearlyout",
        },
        component: () =>
          import(`@/views/client/report/yearly/LateInEarlyOut.vue`),
      },
      {
        path: "report/leave/summary",
        meta: {
          title: "leavesummary",
        },
        component: () => import(`@/views/client/report/leave/Summary.vue`),
      },
      {
        path: "report/leave/detail",
        meta: {
          title: "leavedetail",
        },
        component: () => import(`@/views/client/report/leave/Detail.vue`),
      },
      {
        path: "report/officialvisit/summary",
        meta: {
          title: "officialvisitsummary",
        },
        component: () =>
          import(`@/views/client/report/officialvisit/Summary.vue`),
      },
      {
        path: "report/officialvisit/detail",
        meta: {
          title: "officialvisitdetail",
        },
        component: () =>
          import(`@/views/client/report/officialvisit/Detail.vue`),
      },
      {
        path: "profile",
        meta: {
          name: "User Profile",
        },
        component: () => import(`@/views/UserProfile.vue`),
      },
      {
        path: "utility/dbdownload",
        meta: {
          title: "dbdownload",
        },
        component: () => import(`@/views/client/utility/DBDownload.vue`),
      }
    ],
  },
  {
    path: "/expired",
    name: "expired",
    component: () => import("@/views/Expired.vue"),
  },
  {
    path: "/success",
    name: "success",
    component: () => import("@/views/Message.vue"),
  },
  {
    path: "/404",
    name: "404",
    component: () => import("@/views/NotFound.vue"),
  },
  { path: "*", redirect: "/404" },
];
